import supportData from '../../../data/support/supportData.json';
import { format24HourTime, formatBookingId } from '../../../utils/formatters';

export { format24HourTime, formatBookingId };

/**
 * Format date in clean British format (e.g., 22 Sep 2026)
 */
export const formatTicketDate = (dateInput) => {
  if (!dateInput) return '';
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString([], {
    month: 'short',
    day: 'numeric'
  });
};

/**
 * Deduplicate socket messages against existing conversation thread
 */
export const isMessageDuplicate = (existingList, msg) => {
  if (!existingList || !msg) return false;
  const targetId = msg._id ? String(msg._id) : null;
  const targetText = (msg.text || '').trim();
  const targetSender = msg.sender_type;
  const targetTime = msg.timestamp ? new Date(msg.timestamp).getTime() : 0;

  return existingList.some((m) => {
    if (targetId && m._id && String(m._id) === targetId) return true;
    if (m.sender_type === targetSender && (m.text || '').trim() === targetText) {
      const mTime = m.timestamp ? new Date(m.timestamp).getTime() : 0;
      if (targetTime && mTime && Math.abs(mTime - targetTime) < 5000) return true;
    }
    return false;
  });
};

export { supportData };
